export default {
  searchText(state) {
    return state.searchText;
  },
  onlyPadrao(state) {
    return state.onlyPadrao;
  },
  hasCustomFilters(state) {
    return [
      state.onlyPadrao,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];

    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      filters.push(`(mensagem like '%${searchText}%' or codigoInterno like '%${searchText}%')`);
    }
    if (state.onlyPadrao) {
      filters.push('(padrao is true)');
    }

    return filters.join(' and ');
  },
};
